import { Subject } from 'rxjs';
import { RequestCriteria } from '../../model/request-criteria';
import { RequestCriteriaWithAdditionalInfo } from '../../model/request-criteria-with-additional-info';

export class FilterBuilderService {

  private filtersRequestSubscription = new Subject<void>();
  private filtersSubscription = new Subject<RequestCriteria>();
  private initFiltersSubscription = new Subject<RequestCriteriaWithAdditionalInfo>();

  filtersRequest$ = this.filtersRequestSubscription.asObservable();
  filters$ = this.filtersSubscription.asObservable();
  initFilters$ = this.initFiltersSubscription.asObservable();

  askForFilters(): void {
    this.filtersRequestSubscription.next();
  }

  putFilters(requestCriteria: RequestCriteria): void {
    this.filtersSubscription.next(requestCriteria);
  }

  setInitialFilters(initialFilters: RequestCriteriaWithAdditionalInfo): void {
    this.initFiltersSubscription.next(initialFilters);
  }
}
